export class Connection{
    id : number;
    connString : string;
    connectionName : string;
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/classes/Connection.ts